/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".survey-date[_ngcontent-%COMP%]{font-size:.9rem}.survey-status[_ngcontent-%COMP%]{padding-top:10px}"];
export { styles as styles };
